/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Style } from '../enum/style.enum';
import { DrivenEntity } from './entity/driven-entity';
import dayjs from 'dayjs';
import { SimpleAction } from '../tool/action/simple-action';

export class ListItem extends DrivenEntity {
  public id: number;
  public label: string;
  public date: Date;
  public state: string;
  public color: string;
  public icon: string;
  public active: boolean;

  getInfo(): string {
    return this.state;
  }

  getSubLabel(): string {
    return this.date.toString();
  }

  getDate(): Date {
    return dayjs(this.date).toDate();
  }

  getIcon(): string {
    return this.icon;
  }

  getLabel(): string {
    return this.label;
  }

  isActive(): boolean {
    return this.active;
  }

  getColor(): string {
    return this.color;
  }

  getApi(): string {
    return 'assets/mockApi/list-item.json';
  }

  getId(): string {
    return this.id + '';
  }

  getAlertIcon(): { icon: string; style: Style } {
    return undefined;
  }

  getStatusIcon(): string {
    return '';
  }

  override convert(item: any): any {
    const ticket = new ListItem();
    ticket.id = item.id;
    ticket.color = item.color;
    ticket.state = item.state;
    ticket.label = item.price;
    ticket.active = item.active;
    ticket.icon = item.icon;
    ticket.date = dayjs(item.date, 'DD.MM.YYYY').toDate();
    return ticket;
  }

  serialize(): any {
    return;
  }

  get subLabelStyle(): Style {
    return undefined;
  }

  getActions(): SimpleAction<any>[] {
    return [];
  }
}
